module.exports = __webpack_public_path__ + "static/media/1025034.b3838dc7.png";